import React from 'react';
import "./Home.css"
const home = () => {
    return (
       <div className="homeBackground">
          <main >
            <h1 className="headerHome">WELCOME TO MY WEBSITE</h1>
            <h3 className="subheaderHome">MY NAME IS ROHIT NARAYANAN.
            <br></br> PLEASE HAVE A LOOK AROUND!</h3>
            
            </main>
       </div>
    );
}
 
export default home;

